import { Phone, MessageSquareText } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import { useLang } from "@/lib/i18n";

export default function MobileBottomBar() {
  const { t, lang } = useLang();
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_24px_rgba(15,23,42,0.08)]"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          data-testid="mobile-call-cta"
          href={`tel:${SITE.primaryPhone}`}
          className="inline-flex items-center justify-center gap-2 bg-brand-yellow hover:bg-brand-yellow-dark text-slate-900 font-bold py-3 rounded-xl"
        >
          <Phone size={18} />
          {lang === "es" ? "Llamar" : "Call Now"}
        </a>
        <Link
          data-testid="mobile-quote-cta"
          to="/contact"
          className="inline-flex items-center justify-center gap-2 bg-brand-navy hover:bg-brand-navy/90 text-white font-bold py-3 rounded-xl"
        >
          <MessageSquareText size={18} />
          {lang === "es" ? "Cotización" : "Free Quote"}
        </Link>
      </div>
    </div>
  );
}
